/**
 * Constants for media paths used in the application.
 * These paths are used to reference images, icons, and other media files.
 * @module mediaPath
 */

// ILLUSTRAIONS
export const PATH_EMPTY_ILLUSTRATION = "/images/illustrations/empty.svg";
export const PATH_NO_INTERNET_ILLUSTRATION = "/images/illustrations/noInternet.svg";

// ICONS

// IMAGES
